/** RaiderMapCR - Time utility functions */

export const convertTo12Hour = (time24) => {
  if (!time24) return '';
  
  const [hours24, minutes] = time24.split(':');
  let hours = parseInt(hours24, 10);
  
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  
  return `${hours}:${minutes} ${ampm}`;
};

export const getCurrentDayOfWeek = () => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[new Date().getDay()];
};

export const getCurrentTime24 = () => {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const isTimeInRange = (startTime, endTime, currentTime = getCurrentTime24()) => {
  const [startHour, startMin] = startTime.split(':').map(Number);
  const [endHour, endMin] = endTime.split(':').map(Number);
  const [currentHour, currentMin] = currentTime.split(':').map(Number);
  
  const startMinutes = startHour * 60 + startMin;
  const endMinutes = endHour * 60 + endMin;
  const currentMinutes = currentHour * 60 + currentMin;
  
  return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
};

export const findOccupiedUntilTime = (todaySchedule, currentTime = getCurrentTime24()) => {
  if (!todaySchedule || todaySchedule.length === 0) return null;
  
  const sortedSchedule = todaySchedule.sort((a, b) => a.start_time.localeCompare(b.start_time));
  for (const entry of sortedSchedule) {
    if (isTimeInRange(entry.start_time, entry.end_time, currentTime)) {
      return entry.end_time;
    }
    if (entry.start_time > currentTime) {
      return null;
    }
  }
  return null;
};

export const findNextOccupiedTime = (todaySchedule, currentTime = getCurrentTime24()) => {
  if (!todaySchedule || todaySchedule.length === 0) return null;
  
  const sortedSchedule = todaySchedule.sort((a, b) => a.start_time.localeCompare(b.start_time));
  for (const entry of sortedSchedule) {
    if (entry.start_time > currentTime) {
      return entry.start_time;
    }
  }
  return null;
};

export const getWeekdayOptions = () => [
  { value: 'Monday', label: 'Mon' },
  { value: 'Tuesday', label: 'Tue' },
  { value: 'Wednesday', label: 'Wed' },
  { value: 'Thursday', label: 'Thu' },
  { value: 'Friday', label: 'Fri' }
];
